import * as React from "react";
import {ElementProps} from "src/app/model/ElementProps";

const ImageElement = (props: ElementProps) => {
    return (
        <div className='text-center'>
            <img src={props.element.jsonVal} className='img-element' data-testid='image-element'></img>
        </div>
    )
}

export default ImageElement;